import SongNewForm from '../Components/SongNewForm';

const New = () => {
  return (
    <div className='New'>
      <h2>New</h2>
      <SongNewForm />
    </div>
  );
};

export default New;
